<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title>{{ isUpdateMode == true ? '更新' : '登録' }}</v-card-title>
        <form>

          <v-flex sm8>
            <v-text-field
              v-model="makerName"
              label="会社名"
              v-validate="'required|max:26'"
              :counter="26"
              data-vv-name="makerName"
              :error-messages="errors.collect('makerName')"
              required
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              v-model="tel"
              label="連絡先"
              v-validate="'max:15'"
              :counter="15"
              data-vv-name="tel"
              :error-messages="errors.collect('tel')"
            ></v-text-field>
          </v-flex>          
          <v-layout row>
            <v-flex sm8>
              <v-text-field
                v-model="address"
                label="住所"
                v-validate="'max:33'"
                :counter="33"
                data-vv-name="address"
                :error-messages="errors.collect('address')"
              ></v-text-field>
            </v-flex>
          </v-layout>          
          <v-switch
            v-if="isUpdateMode"
            v-model="isDeleted"
            label="無効にする"
            color="info"
            value="1"
            hide-details
          ></v-switch>

          <div style="height: 55px;"></div>

          <v-layout row wrap style="margin-bottom:20px;">
            <v-flex xs12 sm12>
              <v-btn
                block
                color="success"
                dark
                @click="isUpdateMode == true ? updateMaker() : newMaker()"
                :loading="loading2"
                :disabled="loading2"
              >
                <v-icon class="ma-2" dark small>save</v-icon>
                {{ isUpdateMode == true ? '更新' : '登録' }}する
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-container>
    </v-card>

    <div style="height: 55px;"></div>

    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-maker-maintenance' }">
          <v-icon dark left>arrow_back</v-icon>戻る
        </v-btn>
      </v-flex>
    </v-layout>
    <div style="height: 55px;"></div>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import ServerApiCallService from '@/services/ServerApiCallService.js'

Vue.use(VeeValidate)

export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    console.log('created')

    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this
    this.makerId = this.$route.params.makerId

    if (this.makerId != null) {
      console.log('更新モード')
      
      this.isUpdateMode = true
      
      // getItem on udpate
      let getMakerRequest = { makerId: this.makerId }

      console.log("getMakerRequest: ", getMakerRequest);

      ServerApiCallService.makersById(getMakerRequest)
        .then(response => {
          let makerObj = response.data.maker
          thisObj.makerName = makerObj.makerName
          thisObj.tel = makerObj.tel
          thisObj.address = makerObj.address
          thisObj.isDeleted = makerObj.isDeleted
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    } else {
      console.log('登録モード')
      this.isUpdateMode = false
    }
  },
  methods: {
    // // TODO 今動かない
    // submit() {
    //   this.$validator.validateAll()
    // },
    newMaker() {
      console.log('new maker')
      let thisObj = this
      thisObj.loading2 = true

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        makerName: this.makerName,
        tel: this.tel,
        address: this.address,
        isDeleted: '0'
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-maker-maintenance'
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          thisObj.loading2 = false
          thisObj.dialog3 = true
          return
        }
        ServerApiCallService.makersPost(request, sendContext)
          .then(() => {
            console.log('completed new makers')
            thisObj.loading2 = false
            thisObj.dialog3 = true
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    },
    updateMaker() {
      console.log('update maker')

      let thisObj = this
      thisObj.loading2 = true

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        makerId: this.makerId,
        makerName: this.makerName,
        address: this.address,
        tel: this.tel,
        isDeleted: this.isDeleted == null ? '0' : this.isDeleted
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/new-maker-maintenance'
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          thisObj.loading2 = false
          thisObj.dialog3 = true
          return
        }
        ServerApiCallService.makersPut(request, sendContext)
          .then(() => {
            console.log('completed new makers')
            thisObj.loading2 = false
            thisObj.dialog3 = true
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    }
  },
  data() {
    return {
      isUpdateMode: false,

      loader: null,
      loading: true,
      loading2: false,

      makerId: '',
      makerName: '',
      address: '',
      tel: '',
      isDeleted: '0'
    }
  }
  // mounted() {
  //   this.$validator.localize('en', this.dictionary)
  // }
}
</script>
